import { shape, number, string } from 'prop-types'

const genderType = shape({
  id: number,
  name: string,
})

export default genderType
